import { render, staticRenderFns } from "./ClinicalSkillsTable.vue?vue&type=template&id=647dc417&scoped=true&"
import script from "./ClinicalSkillsTable.vue?vue&type=script&lang=js&"
export * from "./ClinicalSkillsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647dc417",
  null
  
)

export default component.exports